module.exports = __webpack_public_path__ + "img/default-event-capa.c165597f.svg";